import { Controller } from "@hotwired/stimulus";

// Custom country-code dropdown for .input-group--phone — shows real flag
// images (from app/assets/images/flags) instead of a native <select> with emoji.
export default class extends Controller {
  static targets = ["trigger", "flag", "menu", "option", "input", "code"];

  declare readonly triggerTarget: HTMLButtonElement;
  declare readonly flagTarget: HTMLImageElement;
  declare readonly menuTarget: HTMLUListElement;
  declare readonly optionTargets: HTMLLIElement[];
  declare readonly inputTarget: HTMLInputElement;
  declare readonly codeTarget: HTMLElement;

  toggle() {
    this.menuTarget.hidden ? this.open() : this.close();
  }

  open() {
    this.menuTarget.hidden = false;
    this.triggerTarget.setAttribute("aria-expanded", "true");
  }

  close() {
    this.menuTarget.hidden = true;
    this.triggerTarget.setAttribute("aria-expanded", "false");
  }

  select(event: Event) {
    const option = event.currentTarget as HTMLLIElement;
    const { code, flag, label } = option.dataset;

    this.inputTarget.value = code ?? "";
    this.codeTarget.textContent = `+${code}`;
    this.flagTarget.src = flag ?? "";
    this.flagTarget.alt = `${label} flag`;

    this.optionTargets.forEach((o) => o.setAttribute("aria-selected", String(o === option)));
    this.close();
    this.triggerTarget.focus();
  }

  clickOutside(event: Event) {
    if (!this.element.contains(event.target as Node)) this.close();
  }

  keydown(event: KeyboardEvent) {
    if (event.key === "Escape") this.close();
  }
}
